//DAOSection2

// src/components/DAOSection2.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%; 
  background-color: #000000; /* 调整背景颜色根据需要 */
  width:50%;
  margin: 0 auto;

  @media (max-width: 500px) {
    flex-direction: column; /* 在小于500px时，垂直排列 */
    padding: 5% 0%;
    width:90vw;
  }
`;

const LeftColumn = styled.div`
  flex: 4;
  
  @media (max-width: 500px) {

    width:60%;
    text-align: center;
    
  }
  
`;

const Title = styled.h2`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;

  span{
    color: #FFF56A;
  }

  @media (max-width: 500px){
    font-size: 32px;
    line-height: 46px;
  }

`;

const RightColumn = styled.div`
  flex: 6; 
  width:60%;
  overflow: hidden;
  padding:0% 0% 0% 5%;

  @media (max-width: 500px) {
    
    width:100%;
    padding:0% ;

  }
  
`;

const GroupContainer = styled.div`
  margin-bottom: 2.5%; 
  margin-left: 2.5%; 
  background: #1F1F1F;
  border-radius: 12px;
  padding:1%;

  @media (max-width: 500px) {
    width:90%;
    margin:0 auto;
    margin-bottom:2%;
    padding:2%;

  }
`;

const GroupTitle = styled.h3`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 32px;
  margin-bottom: 1%;
  margin-top: 1%; 
  color: #FFFFFF;
  padding:0% 0% 0% 3%;

  span{
    color: #FFF56A;
    padding:0% 2% 0% 0%;
  }

  @media (max-width: 500px) {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`;


const DAOSection2 = () => {
  return (
    <SectionContainer>
      <LeftColumn>
        <Title>分散式自治組織的特性<span>.</span></Title>
      </LeftColumn>
      <RightColumn>
        <GroupContainer>
          <GroupTitle><span>•</span> 價值對齊 Value Aligned</GroupTitle>
         
        </GroupContainer>
        <GroupContainer>
          <GroupTitle><span>•</span> 組織透明 Organizational Transparency</GroupTitle>
       
        </GroupContainer>
        <GroupContainer>
          <GroupTitle><span>•</span> 無須許可 Permissionless</GroupTitle>
        
        </GroupContainer>
        <GroupContainer>
          <GroupTitle><span>•</span> 共同擁有 Equitable Ownership</GroupTitle>
        
        </GroupContainer>
        <GroupContainer>
          <GroupTitle><span>•</span> 協作治理 Collaborative governance</GroupTitle>
        
        </GroupContainer>
      </RightColumn>
    </SectionContainer>


  );
};

export default DAOSection2;
